import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart, Globe, Wallet } from 'lucide-react';
import { useScrollAnimation } from 'hooks/useScrollAnimation';

export const ValueProps = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

    return (
        <section id="value-props" className="py-20 bg-white">
            <div className="container mx-auto px-4" ref={ref}>
                <div className={`text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
                        {t('valueProps.title')}
                    </h2>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        {t('valueProps.subtitle')}
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    <div
                        className={`bg-cyan-50 p-8 rounded-2xl transition-all duration-700 ease-out hover:shadow-xl hover:-translate-y-2 group cursor-default border border-transparent hover:border-primary/10 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                        style={{ transitionDelay: isVisible ? '0.2s' : '0s' }}
                    >
                        <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm text-primary group-hover:scale-110 transition-transform duration-300 group-hover:bg-primary group-hover:text-white group-hover:rotate-6">
                            <Globe size={32} />
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-primary transition-colors">{t('valueProps.cultureTitle')}</h3>
                        <p className="text-gray-600 leading-relaxed">
                            {t('valueProps.cultureDesc')}
                        </p>
                    </div>

                    <div
                        className={`bg-cyan-50 p-8 rounded-2xl transition-all duration-700 ease-out hover:shadow-xl hover:-translate-y-2 group cursor-default border border-transparent hover:border-primary/10 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                        style={{ transitionDelay: isVisible ? '0.4s' : '0s' }}
                    >
                        <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm text-primary group-hover:scale-110 transition-transform duration-300 group-hover:bg-primary group-hover:text-white group-hover:rotate-6">
                            <Wallet size={32} />
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-primary transition-colors">{t('valueProps.priceTitle')}</h3>
                        <p className="text-gray-600 leading-relaxed">
                            {t('valueProps.priceDesc')}
                        </p>
                    </div>

                    <div
                        className={`bg-cyan-50 p-8 rounded-2xl transition-all duration-700 ease-out hover:shadow-xl hover:-translate-y-2 group cursor-default border border-transparent hover:border-primary/10 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                        style={{ transitionDelay: isVisible ? '0.6s' : '0s' }}
                    >
                        <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm text-primary group-hover:scale-110 transition-transform duration-300 group-hover:bg-primary group-hover:text-white group-hover:rotate-6">
                            <Heart size={32} />
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-primary transition-colors">{t('valueProps.supportTitle')}</h3>
                        <p className="text-gray-600 leading-relaxed">
                            {t('valueProps.supportDesc')}
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
};
